/* AartiSanz Theme JS */
document.addEventListener('DOMContentLoaded', function() {

  /* ---- Update cart count badge ---- */
  function refreshCartCount() {
    fetch('/cart.js')
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var el = document.getElementById('cart-count');
        if(el) el.textContent = cart.item_count;
      });
  }

  /* ---- View toggle (grid / list) ---- */
  document.querySelectorAll('.view-btn').forEach(function(btn){
    btn.addEventListener('click', function(){
      document.querySelectorAll('.view-btn').forEach(function(b){ b.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  /* ---- Filter collapse toggle ----
     Purely a class toggle: the CSS handles the animated show/hide
     (.filter-title.collapsed + .filter-body) so no inline style is
     set here — that would otherwise block the transition. */
  document.querySelectorAll('.filter-title').forEach(function(title){
    title.addEventListener('click', function(){
      this.classList.toggle('collapsed');
    });
  });

  /* ---- Wishlist heart toggle ---- */
  document.querySelectorAll('.grid-wishlist').forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault(); e.stopPropagation();
      this.innerHTML = this.innerHTML.includes('♥') ? '&#9825;' : '&#9829;';
      this.style.color = this.innerHTML.includes('♥') ? '' : '#d4380d';
    });
  });

  /* ---- Smooth scroll for mobile filter button ---- */
  var mobileFilterBtn = document.getElementById('mobile-filter-toggle');
  if(mobileFilterBtn){
    mobileFilterBtn.addEventListener('click', function(){
      var sidebar = document.getElementById('filter-sidebar');
      if(sidebar){
        sidebar.style.display = sidebar.style.display === 'block' ? 'none' : 'block';
        if(sidebar.style.display === 'block'){
          sidebar.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  }

});
